//#region types
import { EditableFormInnerProps, GenericFormField } from "models/propTypes/genericFormProps";
//#endregion
//#region components
import useCheckVisibility from "./hooks/useCheckVisibility";
import FormRow from "./formRow";
//#endregion

function EditableFormInnerFields<T extends Record<string, any>>(props: EditableFormInnerProps<T>) {
  const { getFieldHidden } = useCheckVisibility<T>();
  const fields = props.fields as Record<keyof T, GenericFormField<T>>;

  return (
    <>
      {Object.entries(fields).map(([key, field], index) => {
        return (
          !getFieldHidden(field.hidden) && <FormRow<T> {...props} key={`formField-${key}`} name={key} field={field} />
        );
      })}
    </>
  );
}

export default EditableFormInnerFields;
